export type FleetAdminRequest = Record<FleetAdminField, string | undefined>;

export const fleetAdminField = {
    FIRST_NAME: 'firstname',
    LAST_NAME: 'lastname',
    EMAIL: 'email',
    REASON: 'reason',
    PHONE_NUMBER: 'phoneNumber',
    LANGUAGE: 'language',
    IS_GENERAL_CONTACT: 'isGeneralContact',
    IS_BILLING_CONTACT: 'isBillingContact',
} as const;

type FleetAdminField = (typeof fleetAdminField)[keyof typeof fleetAdminField];

export interface EulaStatusUpdateRequest {
    firstname?: string;
    lastname?: string;
    email?: string;
    reason?: string;
}

export const eulaFormField = {
    FIRST_NAME: 'firstname',
    LAST_NAME: 'lastname',
    EMAIL: 'email',
    VERSION: 'eulaVersion',
    REASON: 'reason',
} as const;

export const eulaUpdateStatus = {
    ACCEPTED: 'ACCEPTED',
    REVOKED: 'REVOKED',
} as const;

export type EulaUpdateStatus = (typeof eulaUpdateStatus)[keyof typeof eulaUpdateStatus];
